import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function signInFailure(draft: Draft<IAuthData>) {
  draft.config.isLoading = false;
}

export default signInFailure;
